import React, { Component } from "react";

//  호출 형식
// <Footer handleClickBack={handleClickBack} handleClickSave={handleClickSave} btnInfo={{ backNm: "이전", saveNm: "저장" }} />

const Footer = (props) => {
    const { handleClickBack, handleClickSave, btnInfo } = props;

    return (
        <div className="btnWrap">
            <a className="back" onClick={handleClickBack}>
                {btnInfo.backNm}
            </a>
            <a className="save" onClick={handleClickSave}>
                {btnInfo.saveNm}
            </a>
        </div>
    );
};

export default Footer;
